import React from 'react';
import { ForgotPassword as ForgotPasswordComponent } from './ForgotPassword';
import { useForgotPassword } from './useForgotPassword';

// コンテナコンポーネント
const ForgotPassword: React.FC = () => {
  const forgotPasswordProps = useForgotPassword();
  return <ForgotPasswordComponent {...forgotPasswordProps} />;
};

export default ForgotPassword;

// 個別のエクスポート
export * from './ForgotPassword';
export * from './useForgotPassword';
export * from './types'; 